export default __webpack_public_path__ + "people.481c60.svg";